import type { IStatusSet } from '@platform/core/types';

/**
 * Чи дозволено перехід статусу (правило «linear+skip+reopen» усіх типів записів, як TransitionPolicy.DefaultAllowed бекенду):
 * той самий статус; будь-який наступний за списком; із закритого — повернення до початкового. Невідомий поточний — будь-який. Чиста функція.
 */
export function canMoveStatus(statuses: IStatusSet, from: string | null | undefined, to: string): boolean {
  if (!from || from === to) return true;
  const list = statuses.list;
  const a = list.findIndex((s) => s.value === from);
  const b = list.findIndex((s) => s.value === to);
  if (b < 0) return false;
  if (a < 0 || b > a) return true;
  const initial = statuses.initial ?? list[0]?.value;
  return Boolean(list[a]?.closed) && to === initial;
}

/** Чи статус закритий (виконано, відхилено…) за визначенням типу запису. Чиста функція. */
export function isClosedStatus(statuses: IStatusSet, value: string | null | undefined): boolean {
  return Boolean(value && statuses.list.find((s) => s.value === value)?.closed);
}
